import { createActionName } from './naming';
import * as types from './actionsTypes';

export const sendForm = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SEND_FORM),
  payload
});

export const setFieldOutputAccountsType = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_OUTPUT_ACCOUNTS_TYPE),
  payload
});

export const setFieldAccountNumber = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_ACCOUNT_NUMBER),
  payload
});

export const setFieldBankKey = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_BANK_KEY),
  payload
});

export const setFieldMemoTag = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_MEMO_TAG),
  payload
});

export const setResultObject = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_RESULT_OBJECT),
  payload
});

export const setTrueFormDisabled = reducerName => ({
  type: createActionName(reducerName, types.SET_TRUE_FORM_DISABLED)
});

export const setFalseFormDisabled = reducerName => ({
  type: createActionName(reducerName, types.SET_FALSE_FORM_DISABLED)
});

export const initState = reducerName => ({
  type: createActionName(reducerName, types.INIT_STATE)
});



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccountFrom/actions.js